import React from 'react';
import { Link } from 'react-router-dom';
import StatusIconWithTooltip from '../components/common/StatusIconWithTooltip';

/**
 * Common interface for time off requests
 */
export interface TimeOffRequestRow {
  id: string;
  dateRequested: React.ReactNode;
  dateRequestedSortValue: string;
  hoursRequested: string | number;
  timeOffType: string;
  status: string;
  detail: string;
}

/**
 * Transforms API time off request data to table rows
 * Handles common formatting like date links, status icons, etc.
 * 
 * @param requests - Array of API request objects
 * @param onSelectRequest - Optional callback when a request is clicked
 * @returns Array of formatted table rows
 */
export const transformRequestsToTableRows = (
  requests: any[] = [],
  onSelectRequest?: (request: any) => void
): TimeOffRequestRow[] => {
  const isAdminMode = globalThis.location.pathname.startsWith('/admin');
  const handleNavigation = (requestId: string) => isAdminMode ? `/admin/requestor/status/${requestId}` : `/requestor/status/${requestId}`;
  return requests.map((request: any) => ({
    id: request.requestId,
    dateRequested: (
      <div className="flex items-center justify-between gap-3">
        <Link
          to={handleNavigation(request.requestId)}
          onClick={() => onSelectRequest?.(request)}
          className="p3 -medium underline!"
          style={{
            color: '#0074AD',
            textDecoration: 'underline',
            WebkitPrintColorAdjust: 'exact',
            printColorAdjust: 'exact',
            colorScheme: 'light',
            maxWidth: '400px'
          }}
        >
          {request.todate}
        </Link>
        <StatusIconWithTooltip
          statusCode={request.statusCode}
          alt={request.status}
        />
      </div>
    ),
    dateRequestedSortValue: request.todate,
    hoursRequested: request.hoursRequested,
    timeOffType: request.timeOffReqstType,
    status: request.status,
    detail: request.detail,
  }));
};

/**
 * Common table columns configuration for time off requests
 */
export const DEFAULT_REQUEST_COLUMNS = [
  { key: 'dateRequested', label: 'Date Requested', isSortable: true, sortKey: 'dateRequestedSortValue', className: '!max-w-[500px]' },
  { key: 'hoursRequested', label: 'Hours Requested', isSortable: true },
  { key: 'timeOffType', label: 'Time Off Request Type' },
  { key: 'status', label: 'Request Status' },
  { key: 'detail', label: 'Detail' },
];
